import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { withTranslation } from 'gatsby-plugin-react-i18next'
import { graphql, Link } from 'gatsby'

import StoreContext from 'src/context/StoreContext'
import {
  IS_FOREIGN_COUNTRY,
  LOCALIZATION,
  CAL_BUY_LINK,
  SEASONAL_STATES,
  CURRENT_SEASONAL_STATE,
  IN_SEASONAL_STATE,
  IS_FRAME_SALE,
  COUNTDOWN_EXPIRATIONS,
  VIP_CODE,
  IN_AU,
  IN_CA,
  BUY_LINK,
} from 'src/utils/constants'
import { GatsbyImage } from 'gatsby-plugin-image'
import CalendarNewFeatures from '../components/CalendarNewFeatures'
import CalendarGuarantee from '../components/CalendarGuarantee'
import RedesignCalendarTestimonials from '../components/RedesignCalendarTestimonials'
import CalendarPress from '../components/CalendarPress'
import CalendarMatrix from '../components/CalendarMatrix'
import { CenteredContent, BuyNowLink } from '../components/Hero/styles'

import Hero from '../components/Hero'
import SEO from '../components/seo'
import FramePlusFeatures from '../components/FramePlusFeatures'
import FramePress from '../components/FramePress'
import CalendarTestimonials from '../components/CalendarTestimonials'
import FAQs from '../components/FAQs'
import EffortlessToUse from '../components/EffortlessToUse'
import Guarantee from '../components/Guarantee'
import FreeReturns from '../components/FreeReturns'
import PerfectGift from '../components/PerfectGift'
import { FEATURES } from '../components/FramePlusFeatures/constants'
import { FRAME_FEATURES } from '../components/FrameFeatures/constants'
import { HideOverflow, ContentContainer } from '../utils/styles/global-styles'
import Analytics from '../utils/Analytics'
import FrameFeatures from '../components/FrameFeatures'
import HomepageCalHero from '../components/HomepageCalHero'
import CountDownTimer from '../components/CountDownTimer'
import SeasonalCountdownTimer from '../components/SeasonalCountdownTimer'

import {
  Frame2Container,
  Heading,
  Description,
  CtaContainer,
  BuyNowLinkCTA,
  Flexbox,
  ProductContainer,
} from '../components/HomepageProducts/styles'

class FramePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCountdownVisible: false,
      countdownData:
        IN_SEASONAL_STATE || IS_FRAME_SALE
          ? COUNTDOWN_EXPIRATIONS?.bfcm
          : props?.data?.countdown?.edges?.[0]?.node,

      countdownCountry: `${LOCALIZATION}_countdown`,
    }

    this.handleCountdownComplete = this.handleCountdownComplete.bind(this)
    this.renderCountdown = this.renderCountdown.bind(this)
  }

  componentDidMount() {
    Analytics.track('Viewed Frame Landing Page')
    const { countdownData, countdownCountry } = this.state
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const showCountdown = promoCode === VIP_CODE
    const holidayDate = countdownData?.[countdownCountry] || countdownData?.en_countdown
    const hasHoliday = holidayDate && holidayDate !== 'NONE'
    if (showCountdown || hasHoliday) {
      this.setState({ isCountdownVisible: true })
    }
    if (!IS_FOREIGN_COUNTRY) {
      try {
        const url = new URL(window.location.href)
        const urlParams = new URLSearchParams(url.search)
        const utmCampaign = urlParams.get('utm_campaign')
        const utmTerm = urlParams.get('utm_term')

        if (utmCampaign === 'today' || utmTerm === 'today') {
          const { updateBanner } = this.context
          const channel = 'Today'
          const amount = '20%'
          updateBanner('TODAY', channel, amount)
        } else {
          const { checkUtmParamsForPromo } = this.context
          checkUtmParamsForPromo(window.location.search)
        }
      } catch (error) {
        console.error('Invalid URL:', error)
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const showCountdown = promoCode === VIP_CODE
    if (showCountdown && !prevState.isCountdownVisible) {
      this.setState({ isCountdownVisible: true })
    }
  }

  handleCountdownComplete() {
    this.setState({ isCountdownVisible: false })
  }

  renderCountdown(holidayDate, isBTS = false) {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const { bfcmCore, vip } = SEASONAL_STATES
    const { showHomepageHero: lintingForcedShowHomepageHero } = this.props
    if (IN_SEASONAL_STATE || (IS_FRAME_SALE && CURRENT_SEASONAL_STATE !== 'vip')) {
      return (
        <SeasonalCountdownTimer
          holidayDate={holidayDate}
          holidayState={CURRENT_SEASONAL_STATE ?? bfcmCore}
          onCountdownComplete={this.handleCountdownComplete}
          marginTop={!lintingForcedShowHomepageHero}
          frame
        />
      )
    }

    if (promoCode === VIP_CODE) {
      return (
        <SeasonalCountdownTimer
          holidayDate={holidayDate}
          holidayState={vip}
          onCountdownComplete={this.handleCountdownComplete}
          marginTop={!lintingForcedShowHomepageHero}
          frame
        />
      )
    }

    return isBTS ? (
      <CountDownTimer
        holidayDate={holidayDate}
        page="bts"
        onCountdownComplete={this.handleCountdownComplete}
        ctaLinkOverride={CAL_BUY_LINK}
        marginTop={!lintingForcedShowHomepageHero}
      />
    ) : null
  }

  render() {
    const {
      store: {
        banner: { promoCode },
      },
    } = this.context
    const { t, showHomepageHero, seoAlreadyDefined, data, page } = this.props
    // const { frameProductsImage, mdFrameProduct } = data
    const { frameProductsImage, mdFrameProduct } = data

    const { isCountdownVisible, countdownData, countdownCountry } = this.state
    const IS_BTS = false

    const isVIPState = promoCode === VIP_CODE && !IN_SEASONAL_STATE

    const vipHolidayDate = isVIPState ? COUNTDOWN_EXPIRATIONS?.vip?.[countdownCountry] : null

    const holidayDate =
      vipHolidayDate ?? (countdownData?.[countdownCountry] || countdownData?.en_countdown)
    // const heroVersion = IN_SEASONAL_STATE || isVIPState ? 'bfcm' : null

    return (
      <>
        {!seoAlreadyDefined && (
          <SEO
            title={t('Digital Picture Frames | Skylight Frame')}
            description={t(
              'Skylight is a WiFi-enabled, touchscreen digital frame that lets you easily send pictures to your loved ones by email or mobile app.'
            )}
            canonicalPath="/frame/"
            path="/frame/"
            imagePath={frameProductsImage.childImageSharp.gatsbyImageData.images.fallback.src}
          />
        )}
        <Helmet>
          <meta charset="UTF-8" />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css"
          />
        </Helmet>
        <HideOverflow>
          {showHomepageHero ? <HomepageCalHero page={page} /> : <Hero />}
          {isCountdownVisible &&
            holidayDate &&
            holidayDate !== 'NONE' &&
            this.renderCountdown(holidayDate, IS_BTS)}
          {IN_CA && IN_SEASONAL_STATE && (
            <ProductContainer sunshine>
              <Frame2Container sunshine>
                <GatsbyImage
                  image={mdFrameProduct.childImageSharp.gatsbyImageData}
                  alt="Collection of Skylight Frames displayed for comparison"
                />
                <Flexbox>
                  <Heading>Gift the Moments That Move Her</Heading>
                  <Description>
                    Keep the memories rolling all year long with slideshow photo displays in every
                    size and style.
                  </Description>
                  <CtaContainer>
                    <Link
                      onClick={() =>
                        Analytics.track('Clicked Homepage Frame 2 Buy Now in Features CTA')
                      }
                      to={BUY_LINK}
                    >
                      <BuyNowLinkCTA>Shop Deals</BuyNowLinkCTA>
                    </Link>
                  </CtaContainer>
                </Flexbox>
              </Frame2Container>
            </ProductContainer>
          )}
          {IN_AU ? (
            <>
              <CalendarNewFeatures />
              <CalendarGuarantee
                first
                ctaText={IS_FOREIGN_COUNTRY ? 'Buy Now' : 'Learn more'}
                ctaLink={
                  IS_FOREIGN_COUNTRY
                    ? CAL_BUY_LINK
                    : 'https://skylight.zendesk.com/hc/en-us/articles/360043182612-Refund-and-Return-Policy'
                }
              />
              <HideOverflow>
                <RedesignCalendarTestimonials />
              </HideOverflow>
              <CalendarPress />
              <CalendarMatrix />
              <FAQs page="calendar" />
              <ContentContainer>
                <CenteredContent>
                  <BuyNowLink to={CAL_BUY_LINK}>Buy Now</BuyNowLink>
                </CenteredContent>
              </ContentContainer>
            </>
          ) : (
            <>
              <FramePress />
              <EffortlessToUse title={t('Delightfully Effortless To Use')} />
              <PerfectGift />
              <Guarantee />
              <CalendarTestimonials page="frame" title="Families Rave About Skylight Frame" />
              {!IS_FOREIGN_COUNTRY ? (
                <FrameFeatures features={FRAME_FEATURES} />
              ) : (
                <FramePlusFeatures features={FEATURES} />
              )}
              {!IS_FOREIGN_COUNTRY && <FreeReturns />}
              <FAQs page="frame" />
            </>
          )}
        </HideOverflow>
      </>
    )
  }
}

FramePage.propTypes = {
  t: PropTypes.func,
  data: PropTypes.object,
  showHomepageHero: PropTypes.bool,
  seoAlreadyDefined: PropTypes.bool,
  page: PropTypes.string,
}

FramePage.contextType = StoreContext

export default withTranslation()(FramePage)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { ns: { in: ["common", "frame"] }, language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    countdown: allContentfulCountdownTimer {
      edges {
        node {
          en_au_countdown
          en_ca_countdown
          en_countdown
          en_gb_countdown
        }
      }
    }
    frameProductsImage: file(relativePath: { eq: "meta-seo/frame-products-logo.jpg" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
    mdFrameProduct: file(relativePath: { eq: "md2026/frame_hp_desk.webp" }) {
      childImageSharp {
        gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
      }
    }
  }
`
